import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import SvgIcon from './SvgIcon';

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="group relative inline-flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200/70 bg-white/90 text-slate-600 shadow-md shadow-slate-900/10 transition-all duration-200 hover:-translate-y-0.5 hover:border-blue-200 hover:text-blue-600 hover:shadow-lg hover:shadow-blue-500/15 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-white dark:border-slate-700/70 dark:bg-slate-800/90 dark:text-slate-300 dark:hover:border-blue-400/40 dark:hover:text-blue-400 dark:focus:ring-offset-slate-900"
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      <span className="sr-only">Toggle theme</span>
      <SvgIcon
        name={theme === 'light' ? 'sun' : 'moon'}
        className="h-5 w-5"
      />
    </button>
  );
};

export default ThemeToggle;
